import { Card } from "../ui/Card.js";
import { StanBledu } from "../ui/stany.js";

/**
 * Link nieznany, wygasly albo uniewazniony (404 `link_nieprawidlowy`). Jedno zdanie dla wszystkich trzech przypadkow:
 * serwer tez nie rozroznia ich w odpowiedzi, wiec po komunikacie nie da sie zgadywac tokenow. Czytelna strona w karcie
 * (S-5, S-9), bez kodu bledu: recenzent nie jest programista (S-1).
 */
export function NiewaznyLink(): React.JSX.Element {
  return (
    <>
      <h1 className="page-title">Ten link nie działa</h1>
      <p className="page-lead">Przegląd rozmów jest dostępny tylko pod aktywnym linkiem.</p>
      <Card>
        <StanBledu tytul="Nie możemy otworzyć rozmów" opis="Link jest nieprawidłowy albo wygasł. Poproś o nowy." />
      </Card>
    </>
  );
}
